import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroImage, heroTrust } from '../data/content';
export function Hero() {
  return <section className="w-full bg-cream-100 px-4 pb-9 pt-7 sm:pb-11 sm:pt-9" data-id="element-73" data-mp="9ktcvkgndww6">
      <div className="mx-auto max-w-3xl text-center" data-id="element-74" data-mp="9ipbb96819z2">
        <h1 className="font-display text-[27px] font-black leading-[1.05] tracking-[-0.015em] text-ink sm:text-[38px] lg:text-[44px]" data-id="element-75" data-mp="4mi5dgdtryh4">
          Risolvi un Intero Anno di
          <br className="hidden sm:block" data-id="element-76" data-mp="xanoxzt57hfd" /> Lezioni di Scienze in soli{' '}
          <span className="italic text-brand" data-id="element-77" data-mp="x8bcg265lz9p">5 Minuti</span>
        </h1>

        <p className="mx-auto mt-3 max-w-lg font-sans text-[13.5px] leading-snug text-ink-soft" data-id="element-78" data-mp="s9q93tvluzh1">
          Unisciti a oltre 1.500 insegnanti che hanno smesso di improvvisare. Entri in classe
          con tutto pronto per spiegare, sperimentare e valutare.
        </p>

        <div className="relative mx-auto mt-5 w-full max-w-[380px] sm:max-w-[420px]" data-id="element-79" data-mp="3825xqp13i5ku">
          <img src={heroImage} alt="Il pacchetto SCIENZE PRONTA con oltre 540 schede stampabili di scienze" className="mx-auto max-h-[42vh] w-full rounded-2xl object-contain" width={1244} height={1244} data-id="element-80" data-mp="3j7zgfm2d3yi9" />
        </div>

        <div className="mt-5 flex justify-center" data-id="element-81" data-mp="3e95zfjnv9pdc">
          <CtaButton data-id="element-82" data-mp="3e7uxzqhw8tpe">Ottieni il pacchetto Scienze Pronta™</CtaButton>
        </div>

        <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-83" data-mp="30gztsricb0s5">
          {heroTrust.map(item => <li key={item} className="flex items-center gap-1.5 font-sans text-[11px] font-medium text-ink-muted" data-id="element-84" data-mp="35a2jupnwrs3l">
              <CheckIcon className="h-3 w-3 text-moss" aria-hidden="true" data-id="element-85" data-mp="2vi56bc9fgo1p" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}